<template>
  <div class="home">
    <div class="first">
      <div class="container">
        <div class="company">
          <div class="title">
            <p>源于厦门彰泰隔热膜有限公司</p>
            <p>高端定制品牌</p>
          </div>
          <div class="content hidden-sm-and-down">
            <p>厦门彰泰隔热有限公司旗下 <strong>雷朋、蓝钻、FSK</strong> 三大主流汽车膜品牌。</p>
            <p>FSK是欧美工业+日本精细化工的成果之作,自80年代始步入窗膜领域,</p>
            <p>历经三十几年积累,持续革新产品及客户服务,淬炼并严选高品质的隔热膜,</p>
            <p>坚持仅由无尘环境来生产无毒无害之产品,并同时引领多种革命性前瞻制</p>
            <p>膜技术的问世,如陶瓷隔热技术、多层颜色复合技术、多层金属喷溅、纳</p>
            <p>米涂布、智能光学等;</p>
          </div>
          <div class="content hidden-md-and-up">
            <p>
              厦门彰泰隔热有限公司旗下 <strong>雷朋、蓝钻、FSK</strong> 三大主流汽车膜品牌。
              FSK是欧美工业+日本精细化工的成果之作,自80年代始步入窗膜领域,
              历经三十几年积累,持续革新产品及客户服务,淬炼并严选高品质的隔热膜,
              坚持仅由无尘环境来生产无毒无害之产品,并同时引领多种革命性前瞻制
              膜技术的问世,如陶瓷隔热技术、多层颜色复合技术、多层金属喷溅、纳 米涂布、智能光学等;
            </p>
          </div>
        </div>
        <div class="video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
          >
          </video-player>
        </div>
      </div>
    </div>

    <div class="second">
      <div class="container">
        <div class="products">
          <div class="serise-wrap">
            <div
              class="series"
              :class="{ active: series.id === item.id }"
              v-for="(item, index) in seriesList"
              :key="index"
              @click="seriesClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="data-wrap">
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="version.visible_light"
              ></el-progress>
              <img src="@/assets/visible_light.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.visible_light }}%</div>
                <div class="label">可见光穿透率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                :width="62"
                color="#45dd7d"
                define-back-color="#102a1f"
                :show-text="false"
                :percentage="version.infrared"
              ></el-progress>
              <img src="@/assets/infrared.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.infrared }}%</div>
                <div class="label">红外线阻隔率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="version.ultraviolet"
              ></el-progress>
              <img src="@/assets/infrared.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.ultraviolet }}%</div>
                <div class="label">紫外线阻隔率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="0"
              ></el-progress>
              <img src="@/assets/thickness.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.thickness }}mil</div>
                <div class="label">厚度</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="0"
              ></el-progress>
              <img src="@/assets/warranty.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.warranty }}年</div>
                <div class="label">质保年限</div>
              </div>
            </div>
          </div>
          <div class="feature-wrap">
            <div class="feature" v-for="item in series.features" :key="item.id">
              <div class="item">
                <div class="title">{{ item.title }}</div>
                <div class="desc" v-html="item.desc"></div>
                <div class="tip" v-if="item.tip">{{ item.tip }}</div>
              </div>
            </div>
          </div>
          <div class="version-wrap">
            <div
              class="version"
              v-for="v in versionList"
              :key="v.id"
              :class="{ active: version.id === v.id }"
              @click="selectVersion(v)"
            >
              {{ v.name }} <span>{{ v.range }}</span>
            </div>
          </div>
          <div class="tip">技术参数均为原厂提供测试参考值，非保证值。测量工具不同，数据略有偏差</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { getSeriesList } from '@/api/index'

export default {
  name: 'Home',
  components: {
    videoPlayer
  },
  data() {
    return {
      playerOptions: {
        muted: true,
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        loop: false,
        preload: 'auto',
        aspectRatio: '16:9',
        sources: [
          {
            type: 'video/mp4',
            src: require('@/assets/fsk_video.mp4')
          }
        ],
        poster: require('@/assets/fsk_video_img.png'),
        notSupportedMessage: '此视频暂无法播放，请稍后再试'
      },
      seriesList: [],
      versionList: [],
      series: {},
      version: {}
    }
  },
  created() {
    this.loadSeriesData()
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    loadSeriesData() {
      getSeriesList({ show_index: 1 })
        .then((res) => {
          this.seriesList = res.data.map((item) => {
            item.features = item.features.map((f) => {
              f.desc = f.desc.replace(/\\n/g, '<br/>')
              return f
            })
            return item
          })
          const [first] = res.data
          this.series = first
          this.versionList = first.versions
          this.version = first.versions[0]
        })
        .catch((err) => {
          this.$message.error(err.msg || '加载数据失败')
        })
    },
    seriesClick(series) {
      this.series = series
      this.versionList = series.versions
      this.version = series.versions[0]
    },
    selectVersion(v) {
      this.version = v
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.first {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('~@/assets/bg_1.jpg') no-repeat center/cover;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    box-sizing: border-box;
    gap: 20px;
    .company {
      flex: 1 1 50%;
      box-sizing: border-box;
      color: #fff;
      .title {
        position: relative;
        padding-bottom: 10px;
        margin-bottom: 20px;
        font-size: 36px;
        font-weight: bold;
        p {
          margin-top: 0;
          margin-bottom: 10px;
        }
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 80px;
          height: 4px;
          background-color: #fff;
        }
      }
      .content {
        font-size: 16px;
        p {
          margin-top: 0;
          margin-bottom: 10px;
        }
      }
    }
    .video {
      flex: 1 1 50%;
      box-sizing: border-box;
    }
  }
}
.second {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .container {
    .products {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 70px 20px;
      box-sizing: border-box;
      color: $--color-primary;
      .serise-wrap {
        display: flex;
        justify-content: space-around;
        margin-bottom: 50px;
        background-color: #a0a0a0;
        .series {
          flex: auto;
          height: 70px;
          line-height: 70px;
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          text-align: center;
          cursor: pointer;
          user-select: none;
        }
        .active {
          background-color: $--color-primary;
          color: #fff;
        }
      }
      .data-wrap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 50px;
        .item {
          position: relative;
          display: flex;
          align-items: center;
          gap: 18px;
          img {
            position: absolute;
            left: 15px;
            top: 15px;
            width: 32px;
            height: 32px;
          }
          .item-wrap {
            align-self: stretch;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .value {
              font-size: 28px;
              color: #333;
              font-weight: bold;
            }
            .label {
              font-size: 18px;
              color: #333;
            }
          }
        }
      }
      .feature-wrap {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
        .feature {
          position: relative;
          padding-left: 20px;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 6px;
            background-color: $--color-primary;
          }
          .item {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              margin-bottom: 10px;
              font-size: 22px;
              font-weight: bold;
            }
            .desc {
              font-size: 16px;
              color: #000;
              font-weight: 400;
            }
            .tip {
              margin-top: 8px;
              font-size: 14px;
              font-weight: 400;
              opacity: 0.5;
              margin-top: 8px;
            }
          }
        }
      }
      .version-wrap {
        display: flex;
        justify-content: space-between;
        gap: 30px;
        margin-top: 70px;
        .version {
          flex: auto;
          height: 70px;
          padding: 0 30px;
          border: 1px solid #aaa;
          line-height: 70px;
          font-size: 30px;
          font-weight: bold;
          text-align: center;
          color: #aaa;
          cursor: pointer;
          span {
            font-size: 16px;
          }
        }
        .active {
          color: $--color-primary;
          border-color: $--color-primary;
        }
      }
      & > .tip {
        text-align: center;
        margin: 10px;
        color: #aaa;
      }
    }
  }
}

@media screen and (max-width: 991px) {
  .first {
    height: auto;
    .container {
      flex-direction: column;
      align-items: stretch;
      .company {
        .title {
          font-size: 26px;
        }
      }
    }
  }
  .second {
    .container {
      .products {
        padding: 30px 20px;
        .serise-wrap {
          margin-bottom: 30px;
          .series {
            font-size: 22px;
          }
        }
        .data-wrap {
          flex-direction: column;
          gap: 20px;
          margin-bottom: 30px;
        }
        .feature-wrap {
          grid-template-columns: repeat(1, 1fr);
          gap: 30px;
          .feature {
            margin-bottom: 20px;
          }
        }
        .version-wrap {
          margin-top: 30px;
          flex-direction: column;
          .version {
            height: 50px;
            line-height: 50px;
            font-size: 17px;
            text-align: center;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1199px) {
  .first,
  .second {
    .container {
      width: 100%;
    }
  }
}

@media screen and (min-width: 1200px) {
  .first,
  .second {
    .container {
      width: 1200px;
    }
  }
}
</style>
